import React from "react";
import {Col, Row, Table, Typography} from "antd";
import type {EventUserStatistics} from "../../../services/drinkService";
import type {TFunction} from "i18next";
import {formatAlcohol, formatVolume} from "./utils";
const {Title}=Typography;
const buildBreakdownColumns = (title: string, dataIndex: string) => [
    { title, dataIndex },
    { title: "Liquid", dataIndex: "totalVolumeMl", align: "right" as const, render: formatVolume },
    { title: "Pure alcohol", dataIndex: "totalAlcoholGrams", align: "right" as const, render: formatAlcohol },
];

type ParticipantBreakdownProps = {
    record: EventUserStatistics;
    scroll: { x: "max-content" } | undefined;
    t: TFunction;
};

const ParticipantBreakdown: React.FC<ParticipantBreakdownProps> = ({ record, scroll, t }) => (
    <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
            <Title level={3}>{t("eventStats.cards.categoryBreakdown")}</Title>
            <section className="event-stats-table" tabIndex={0 /* NOSONAR - required for keyboard scrolling */} aria-label={`${record.username}: ${t("eventStats.cards.categoryBreakdown")}`}>
                <Table
                    scroll={scroll}
                    size="small"
                    pagination={false}
                    rowKey={(item) => item.category}
                    columns={buildBreakdownColumns("Category", "category")}
                    dataSource={record.categories}
                />
            </section>
        </Col>
        <Col xs={24} md={12}>
            <Title level={3}>{t("eventStats.cards.drinkBreakdown")}</Title>
            <section className="event-stats-table" tabIndex={0 /* NOSONAR - required for keyboard scrolling */} aria-label={`${record.username}: ${t("eventStats.cards.drinkBreakdown")}`}>
                <Table
                    scroll={scroll}
                    size="small"
                    pagination={false}
                    rowKey={(item) => `${record.userId}-${item.drinkId}`}
                    columns={buildBreakdownColumns("Drink", "drinkName")}
                    dataSource={record.allDrinks ?? record.topDrinks}
                />
            </section>
        </Col>
    </Row>
);


export default ParticipantBreakdown;
